export default {"src":"/_next/static/media/0xbb2b8038a1640196fbe3e38816f3e67cba72d940.2e1b6b93.svg","height":129,"width":129,"blurWidth":0,"blurHeight":0};